import useResourceAPI from "../Base/Hooks/resourceAPI";

const usePersonsAPI = (props) => useResourceAPI({ ...props, resourceName: "persons" });

export default usePersonsAPI;
